import { render, staticRenderFns } from "./sliderDoc.vue?vue&type=template&id=2fd2cc32&scoped=true&"
import script from "./sliderDoc.vue?vue&type=script&lang=js&"
export * from "./sliderDoc.vue?vue&type=script&lang=js&"
import style0 from "./sliderDoc.vue?vue&type=style&index=0&id=2fd2cc32&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd2cc32",
  null
  
)

export default component.exports